export const getDefaultApiUrl = (): string => 'https://helix.use1.hqo-preprod.com';
